import React from "react";
import { useLocation } from "react-router-dom";
import General from "./General";
import Applicants from "./Applicants.js";
import Requests from "./Requests";
import IdealTalents from "./IdealTalents";

const Jobs = () => {
  const { pathname } = useLocation();
  const isApplicantsPage = pathname.includes("applicants");

  return (
    <div className="my-4 mx-1 mx-md-4">
      <div className="w-100 my-4">
        {isApplicantsPage ? (
          <Applicants />
        ) : pathname.includes("requests") ? (
          <Requests />
        ) : pathname.includes("ideal-talents") ? (
          <IdealTalents />
        ) : (
          <General />
        )}
      </div>
    </div>
  );
};

export default Jobs;
